import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { CHART_METRICS } from '../../constants';

type ChartMetricToggleProps = {
  activeMetric: PerformanceAudienceChartMetric;
  onChange: (metric: PerformanceAudienceChartMetric) => void;
  className?: string;
};

const METRIC_LABEL_KEYS: Record<PerformanceAudienceChartMetric, string> = {
  impressions: 'trend.metrics.impressions',
  clicks: 'trend.metrics.clicks',
  cost: 'trend.metrics.cost',
  ctr: 'trend.metrics.ctr',
};

export const ChartMetricToggle: FC<ChartMetricToggleProps> = ({ activeMetric, onChange, className }) => {
  const { t } = useTranslation('performanceAudience');

  return (
    <div role='tablist' aria-label={t('trend.metricsLabel')} className={twMerge('inline-flex rounded-lg border border-primary-border bg-primary-50 p-1', className)}>
      {CHART_METRICS.map((metric) => {
        const isActive = metric === activeMetric;

        return (
          <button
            key={metric}
            type='button'
            role='tab'
            aria-selected={isActive}
            onClick={() => onChange(metric)}
            className={twMerge(
              'rounded-md px-3 py-1.5 text-xs font-semibold capitalize transition-colors',
              isActive ? 'bg-white text-brand-700 shadow-sm' : 'text-primary-600 hover:text-primary-900'
            )}
          >
            {t(METRIC_LABEL_KEYS[metric] as 'trend.metrics.impressions')}
          </button>
        );
      })}
    </div>
  );
};
